import React, { Component } from 'react';
import './styles.scss';

type Props = {
  text: string;
  show: boolean;
  hideNotification: Function;
};
type State = {};

export default class Notification extends Component<Props, State> {
  timeoutID: any;

  componentDidUpdate(prevProps: Props) {
    if (prevProps.text !== this.props.text && this.props.text) {
      clearTimeout(this.timeoutID);
      this.timeoutID = setTimeout(() => {
        this.props.hideNotification();
      }, 3000);
    }
  }

  render() {
    return (
      <div
        className={`sf-notification ${this.props.show ? '' : 'hide'} clickable`}
        onClick={() => {
          this.props.hideNotification();
        }}>
        {this.props.text}
      </div>
    );
  }
}
